import React, { Component } from 'react';
import {
  Button,
  Modal,
  Table,
  Tooltip,
  Row,
  Col,
  Icon,
  Form,
  Input,
  Select
} from 'antd';
import axios from 'axios';
import Moment from 'react-moment';
import { Constant } from "../../../config";
import CostDetail from "./CostDetail";
import CostCompare from "./CostCompare"
import { debounce } from "lodash";
import '../PriceManagement.css';
import ChangeLogs from "./ChangeLogs";

const ButtonGroup = Button.Group;
const sortBySelection = [
  { name: "Default", value : "id" },
  { name: "Price", value: "price" },
  { name: "Create Time", value: "created_date" }
]
const statusSelection = [
  { name: "All Gateway", value : "" },
  { name: "Main Gateway", value: "true" },
  { name: "Nomal Gateway", value: "false" }
]


class Vendor extends Component {
  state = {
    gateWayCountry: [],
    totalGateway: 0,
    mainGateway: 0,
    pagination: {},
    loading: false,
    enableCostDetailModal: false,
    enableCostCompareModal: false,
    enableChangeLogsModal: false,
    gatewayId: 0,
    gatewayName: '',
    countryList: [],
    compareRegionCode: '',
    compareCountryName: '',
    isEditCost: false,
    costGatewayCountry: {},
    costCountryName: '',
  };

  columns = [
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (text, record) => {
        return record.country_abbr ? this._findCountryName(record.country_abbr) : '-'
      },
      align: 'center',
    },
    {
      title: 'Cost Price',
      dataIndex: 'cost_price',
      key: 'cost_price',
      render: (text, record) => {
        if (!record.price) return '-'
        return Number.parseFloat(record.price).toFixed(4)
      },
      align: 'center',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        if (record.is_main_gateway === null) return '-'
        return record.is_main_gateway ? <span style={{color: '#1890ff'}}>Main Gateway</span> : <span style={{color: 'rgba(0, 0, 0, 0.45)'}}>Nomal Gateway</span>
      },
      align: 'center',
    },
    {
      title: 'Last Update',
      dataIndex: 'updated_date',
      key: 'updated_date',
      render: (text, record) => {
        if (record.updated_date === 0) return '-'
        return <div>
          <div>{record.last_change_logs.event === 'update' ? 'Edit Price' : 'Set to Main'}</div>
          <Moment style={{color: 'rgba(0, 0, 0, 0.45)'}} unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">{record.updated_date}</Moment>
        </div>
      },
      align: 'center',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
            <ButtonGroup>
              <Tooltip placement="top" title="Edit" onClick={() => this._costPriceAction(record, true)}>
                <Button icon="edit" />
              </Tooltip>
              <Tooltip placement="top" title="Cost Compare">
                <Button icon="swap" onClick={() => this._compareCostPrice(record)} />
              </Tooltip>
            </ButtonGroup>
        );
      },
      align: 'center',
    },
  ];

  componentWillMount() {
    const { gatewayId } = this.props
    const countryList = this.props.countryList
    this.setState({
      gatewayId,
      countryList
    })
  }

  async componentDidMount() {
    await this._fetchVendorList()
  }

  _fetchVendorList = async (page = 1, limit = 10, filter = {order_by: 'id', order: 'asc', search: '', is_main_gateway: ''}) => {
    this.setState({ loading: true })

    const url = `${Constant.COST_PRICE_GATEWAY_API.replace("[id]", this.state.gatewayId)}`;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let pagination = { ...this.state.pagination };
    pagination.size = 'small';

    if (resp.data) {
      let data = resp.data;
      pagination.total = data.total;
      this.setState({
        loading: false,
        gateWayCountry: data.data,
        totalGateway: data.total_gateway,
        mainGateway: data.total_main_gateway,
        gatewayName: data.name,
        pagination
      });
    }
  };

  _handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this._fetchVendorList(pager.current, pagination.pageSize);
  };

  _handleSearchChange = (values) => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({ 
      pagination,
      filter: values
    });
    this._fetchVendorList(1, 10, values);
  };

  _compareCostPrice = (record) => {
    this.setState({
      enableCostCompareModal: true,
      compareRegionCode: record.country_abbr,
      compareCountryName: this._findCountryName(record.country_abbr)
    })
  }

  _costPriceAction = (record, actionType) => {
    this.setState({
      isEditCost: actionType,
      enableCostDetailModal: true,
      costGatewayCountry: record,
      costGateWayName: this.state.gatewayName,
      costCountryName: this._findCountryName(record.country_abbr)
    })
  }

  _viewChangeLogs = () => {
    this.setState({
      enableChangeLogsModal: true
    })
  }

  _onCloseCostDetailModal = () => {
    this.setState({ 
      enableCostDetailModal: false
    });
  }

  _onViewVendor = async (gatewayId) => {

    this.setState({ enableCostCompareModal: false })

    // return if gatewayId dupplicate
    if (gatewayId === this.state.gatewayId) return;

    // change gatewayId and fetch vendor
    await this.setState({
      gatewayId
    })
    await this._fetchVendorList()
  }

  _handleHasCostPriceAct = () => {
    this.setState({ 
      enableCostDetailModal: false
    });
    const pager = { ...this.state.pagination };
    this._fetchVendorList(pager.current, 10, this.state.filter);
  }

  _onCloseCostCompareModal = () => {
    this.setState({ 
      enableCostCompareModal: false,
      compareRegionCode: '',
      compareCountryName: ''
    });
  }

  _onCloseChangeLogsModal = () => {
    this.setState({
      enableChangeLogsModal: false
    })
  }
  
  _findCountryName = (regionCode) => {
    if (!regionCode) return '-'
    const country = this.state.countryList.find((c) => {
      return c.region_code === regionCode.toUpperCase();
    })
    return country.name || '-';
  }

	render() {
    const { onCancel, visible } = this.props;
    let propsTable = {
      columns: this.columns,
      dataSource: this.state.gateWayCountry,
      rowKey: (record) => record.key,
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this._handleTableChange
    };

		return (
			<Modal
        className="my-layout"
        footer={
          <div style={{textAlign: 'center'}}>
            <Button key="cancel" onClick={onCancel}>
              Close
            </Button>
            <Button key="changeLog" type="primary" onClick={this._viewChangeLogs}>
              View Change Logs
            </Button>
          </div>
        }
        onCancel={onCancel}
        closable={false}
        title={
          <div className='vendor-modal'>
            <Row type='flex' align="middle">
              <Col sm={{span: 24}} md={{span: 12}}>
                <Row type='flex' align="middle" className='gateway-title'>
                  <Col className='gateway-name'>{this.state.gatewayName}</Col>
                  <Col className='total-gateway'><div className=''>Gateway</div><div>{this.state.totalGateway} Country</div></Col>
                  <Col className='main-gateway'><div>Main Gateway</div><div>{this.state.mainGateway} <span>Country</span></div></Col>
                </Row>
              </Col>
              <Col sm={{span: 24}} md={{span: 12}}>
                <Row type='flex' justify="end" align="middle">
                  <Col>
                    <Button type="primary" onClick={() => this._costPriceAction('', false)}>
                      <Icon type="plus" />
                      Add Cost
                    </Button>
                  </Col>
                  <Col style={{marginLeft: 10}}><Icon type="close" onClick={onCancel} /></Col>
                </Row>
              </Col>
            </Row>
          </div>
        }
        visible={visible}
        width={1200}
      >
        <VendorSearchForm onSearch={this._handleSearchChange}/>
        <Table {...propsTable} />
        {this.state.enableCostDetailModal && 
          <CostDetail 
            visible={this.state.enableCostDetailModal}
            data={this.state.costGatewayCountry}
            onCancel={this._onCloseCostDetailModal}
            countryList={this.state.countryList}
            gatewayName={this.state.gatewayName}
            costCountryName={this.state.costCountryName}
            isEditCost={this.state.isEditCost}
            gatewayId={this.state.gatewayId}
            addCostFromList={false}
            hasActivity={this._handleHasCostPriceAct}
          />
        }
        {this.state.enableCostCompareModal && 
          <CostCompare 
            visible={this.state.enableCostCompareModal}
            regionCode={this.state.compareRegionCode}
            countryName={this.state.compareCountryName}
            onCancel={this._onCloseCostCompareModal}
            viewVendor={this._onViewVendor}
          />
        }
        {this.state.enableChangeLogsModal && 
          <ChangeLogs 
            visible={this.state.enableChangeLogsModal}
            onCancel={this._onCloseChangeLogsModal}
            countryList={this.state.countryList}
            gatewayId={this.state.gatewayId}
          />
        }
      </Modal>
		)
	}
}

const VendorSearchForm = Form.create({name: "vendor_search_form"})(
	class extends Component {

    async componentDidMount() {
      await this.setFieldsValue();
    }
    
    setFieldsValue = () => {
      this.props.form.setFieldsValue({
        search: '',
        order_by: 'id',
        is_main_gateway: ''
      });
    }

    handleChangeSearch = (event) => {
      event.persist();
      if (!this.debouncedFn) {
        this.debouncedFn = debounce(() => {
          this.props.form.setFieldsValue({
            search: event.target.value
          });
          this.handleOnSearch()
        }, 600);
      }
  
      this.debouncedFn();
    }

    handleChangeSort = (event) => {
      this.props.form.setFieldsValue({
        order_by: event
      });
      this.handleOnSearch()
    }

    handleChangeStatus = (event) => {
      this.props.form.setFieldsValue({
        is_main_gateway: event
      });
      this.handleOnSearch()
    }

    handleOnSearch = () => {
      this.props.form.validateFields((err, values) => {
        this.props.onSearch(values);
      });
    };

    render() {
      const { getFieldDecorator } = this.props.form;

      return (
        <Form layout="inline">
          <Row gutter={24}>
            <Col xs={{span: 24}} md={{span: 12}}>
              <Form.Item>
                {getFieldDecorator('search')(
                  <Input
                    type='text'
                    onChange={this.handleChangeSearch}
                    prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }}/>}
                    placeholder="Search Country"
                  />,
                )}
              </Form.Item>
            </Col>
            <Col xs={{span: 24}} md={{span: 12}}>
              <Row gutter={24} type='flex' justify="end">
                <Col>
                  <Form.Item label="Status">
                    {getFieldDecorator('is_main_gateway')(
                      <Select
                        onChange={this.handleChangeStatus}
                      >
                      {statusSelection.map((sort, idx) => {
                        return (
                          <Select.Option key={idx} value={sort.value}>
                            {sort.name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label="Sort By">
                    {getFieldDecorator('order_by')(
                      <Select
                        placeholder="Sort By"
                        onChange={this.handleChangeSort}
                        style={{ width: '130px' }}
                      >
                      {sortBySelection.map((sort, idx) => {
                        return (
                          <Select.Option key={idx} value={sort.value}>
                            {sort.name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      )
    }
	}
);

export default Vendor


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/Modals/Vendor.js